import React, { FC, useEffect } from "react";
import useSWR from "swr";

import { Body, Footer, Header, Section } from "@in/component-library";

import { getSignedOutLayout } from "../../apis/get-signed-out-layout";

import CookieSettings from "../../components/cookie-settings/cookie-settings";
import SkipToContent from "../../components/skip-to-content/skip-to-content";
import UXSignalsWidget from "../../components/UX-signals-widget/UX-signals-widget";
import { useLayout } from "../../hooks/use-layout";

const SignedOutPage: FC = () => {
  const { data: layout } = useSWR("layout/signed-out-layout", getSignedOutLayout);
  const { translations } = useLayout();

  useEffect(() => {
    document.title = translations.signedOutTitle;
  }, [translations]);

  return (
    <div className="page">
      <SkipToContent />
      <Header logoAriaLabel="Til forsiden" logoLink={layout?.logoUrl ?? ""} />
      <Body id="maincontent">
        <Section>
          <div
            className="signed-out-page"
            dangerouslySetInnerHTML={{
              __html: layout?.translations?.signedOutPageText ?? ""
            }}
          />
        </Section>
        <Section className="uxSignalSection">
          <UXSignalsWidget isReadyToLoadScript={layout !== undefined} id="panel-f4mdn0086g" />
        </Section>
      </Body>
      <Footer className="layout__footer">
        <div dangerouslySetInnerHTML={{ __html: layout?.footerText1 ?? "" }} />
        <div>
          <div dangerouslySetInnerHTML={{ __html: layout?.footerText2 ?? "" }} />
          <CookieSettings />
        </div>
      </Footer>
    </div>
  );
};

export default SignedOutPage;
